import {
  Grid2 as Grid,
  TextField,
  Typography,
  Box,
  Card,
  Divider,
  Button,
} from "@mui/material";
import { FaSignature } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSignerField,
  toggleImSigner,
  emptySigner,
} from "../../store/actions/userPackagesActions";
import { useEffect, useState } from "react";

const RenderedPackageFormFields = ({ setCurrentProcessingFile }) => {
  const dispatch = useDispatch();
  const { selectedPackage, selectedPackageForm } = useSelector(
    (state) => state.userPackages
  );
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const [mySigner, setMySigner] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    company_name: "",
    email: "",
    phone_number: "",
    address: "",
  });

  useEffect(() => {
    const personal = currentUser?.user?.personal?.[0];
    const isSub = currentUser?.subuser;
    const myEmail = !currentUser?.subuser
      ? currentUser?.user?.email
      : currentUser?.subuser?.email;

    const contractorUser = currentUser?.user?.contractors.find(
      (contractor) => contractor?.email === myEmail
    );

    if (contractorUser) {
      setMySigner({
        first_name: contractorUser?.firstName,
        middle_name: contractorUser?.middleName,
        last_name: contractorUser?.lastName,
        company_name: contractorUser?.businessName,
        email: contractorUser?.email,
        phone_number: contractorUser?.mobile,
        address: contractorUser?.mainAddress,
      });
    } else {
      setMySigner({
        first_name: !isSub ? personal?.firstName : isSub?.first,
        middle_name: !isSub ? personal?.middleName : "",
        last_name: !isSub ? personal?.lastName : isSub?.last,
        company_name: "",
        email: myEmail,
        phone_number: !isSub ? personal?.phone : "",
        address: !isSub ? personal?.address : "",
      });
    }
  }, [currentUser]);

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {Object.entries(selectedPackage?.signers || {}).map(
        ([signerKey, signer], index) => {
          const color =
            index === 0
              ? "RGBA(60, 145, 80, 0.6)"
              : index === 1
              ? "RGBA(175, 60, 60, 0.6)"
              : "RGBA(140, 80, 180, 0.6)";

          const anyImSignerSelected = Object.entries(
            selectedPackage?.signers || {}
          ).some(([key, val]) => val?.im_sign && key !== signerKey);

          return (
            <Grid size={{ xs: 12 }} key={signerKey}>
              <Card
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  mb: 0,
                  boxShadow: "3px 5px 6px 4px rgba(0, 0, 0, 0.2) !important",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: color,
                    borderRadius: 1,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    p: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      minHeight: "2.25rem",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        textTransform: "uppercase",
                      }}
                    >
                      {signer?.label || `Signer ${index + 1}`}
                    </Typography>
                    <FaSignature size={18} color="white" />
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {!anyImSignerSelected || signer?.im_sign ? (
                      <Button
                        variant={signer?.im_sign ? "contained" : "outlined"}
                        size="small"
                        onClick={() => {
                          const isCurrentlySelected = signer?.im_sign;
                          

                          if (isCurrentlySelected) {
                            // Clear fields
                            dispatch(
                              emptySigner(selectedPackage?.packageID, signerKey)
                            );

                            setCurrentProcessingFile((prev) => ({
                              ...prev,
                              signers: {
                                ...prev.signers,
                                [signerKey]: {
                                  ...prev.signers?.[signerKey],
                                  first_name: "",
                                  middle_name: "",
                                  last_name: "",
                                  company_name: "",
                                  email: "",
                                  phone_number: "",
                                  address: "",
                                  im_sign: false,
                                },
                              },
                            }));

                            return;
                          }

                          // Fill with data from mySigner
                          dispatch(
                            toggleImSigner(
                              selectedPackage?.packageID,
                              signerKey,
                              mySigner
                            )
                          );

                          setCurrentProcessingFile((prev) => {
                            const updatedSigners = {};

                            for (const key in prev?.signers || {}) {
                             
                              const isSelected = signerKey === key;

                              updatedSigners[key] = {
                                ...prev.signers[key],
                                im_sign: isSelected,
                                ...(isSelected
                                  ? mySigner
                                  : {
                                      first_name: "",
                                      middle_name: "",
                                      last_name: "",
                                      company_name: "",
                                      email: "",
                                      phone_number: "",
                                      address: "",
                                    }),
                              };
                            }

                            return {
                              ...prev,
                              signers: updatedSigners,
                            };
                          });
                        }}
                        sx={{
                          color: signer?.im_sign ? "#000" : "#fff", // White text only in outlined
                          backgroundColor: signer?.im_sign
                            ? "#fff"
                            : "transparent",
                          borderColor: "#fff",
                          "&:hover": {
                            backgroundColor: signer?.im_sign
                              ? "#f0f0f0"
                              : "rgba(255,255,255,0.1)",
                            borderColor: "#fff",
                          },
                        }}
                      >
                        I'm the signer
                      </Button>
                    ) : null}
                  </Box>
                </Box>

                <Divider sx={{ my: 0.5 }} />

                <Grid container spacing={2}>
                  {[
                    { key: "first_name", label: "First Name" },
                    { key: "middle_name", label: "Middle Name" },
                    { key: "last_name", label: "Last Name" },
                    { key: "company_name", label: "Company Name" },
                    { key: "email", label: "Email" },
                    { key: "phone_number", label: "Phone Number" },
                    { key: "address", label: "Address" },
                  ].map(({ key, label }) => (
                    <Grid
                      size={{ xs: 12, sm: key === "address" ? 12 : 6 }}
                      key={key}
                    >
                      <TextField
                        disabled={selectedPackageForm?.locked}
                        fullWidth
                        label={label}
                        value={signer?.[key] || ""}
                        onChange={(e) => {
                          dispatch(
                            updateSignerField(
                              selectedPackage?.packageID,
                              signerKey,
                              key,
                              e.target.value
                            )
                          );

                          setCurrentProcessingFile((prev) => ({
                            ...prev,
                            signers: {
                              ...prev.signers,
                              [signerKey]: {
                                ...prev.signers?.[signerKey],
                                [key]: e.target.value,
                              },
                            },
                          }));
                        }}
                        variant="filled"
                      />
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Grid>
          );
        }
      )}
    </Grid>
  );
};

export default RenderedPackageFormFields;
